import React, { FC, ReactNode, useEffect, useState } from 'react'
import { useSiteMetadata } from '../../../lib/sanity/hooks/useSiteMetadata'
import * as Styled from './styled'

interface RegistrationLegacyGuardProps {
  allowPLPractitioner: boolean
  allowPLUnlicensed: boolean
  children: ReactNode
}

export const RegistrationLegacyGuard: FC<RegistrationLegacyGuardProps> = ({
  allowPLPractitioner,
  allowPLUnlicensed,
  children,
}) => {
  const { registrationRedirectUrl } = useSiteMetadata() || {}
  const [countdown, setCountdown] = useState(5)
  const isLegacyRegistrationEnabled = allowPLPractitioner || allowPLUnlicensed

  useEffect(() => {
    if (isLegacyRegistrationEnabled || !registrationRedirectUrl) {
      return
    }
    if (countdown === 0) {
      // replace so Back does not return to this page and bounce the visitor again
      window.location.replace(registrationRedirectUrl)
      return
    }
    const timer = setTimeout(() => setCountdown(countdown - 1), 1000)
    return () => clearTimeout(timer)
  }, [countdown, isLegacyRegistrationEnabled, registrationRedirectUrl])

  if (!isLegacyRegistrationEnabled) {
    return (
      <Styled.Container>
        <Styled.InfoHeader>
          Our website has been renewed, and this login page is no longer in use.
        </Styled.InfoHeader>
        <Styled.InfoHeader style={{ marginTop: '24px' }}>
          You’ll be redirected to our new site...
        </Styled.InfoHeader>
        <Styled.InfoHeader style={{ marginTop: '32px' }}>{countdown}</Styled.InfoHeader>
        <Styled.Helper style={{ fontSize: '16px', marginTop: '24px' }}>
          Or{' '}
          <Styled.Link href={registrationRedirectUrl}>
            click here to redirect immediately
          </Styled.Link>
        </Styled.Helper>
      </Styled.Container>
    )
  }

  return <>{children}</>
}
